import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import StartpageElementViewModel from '@/ViewModels/Controls/StartpageElementViewModel';

export default class StartpageGroupViewModel extends ControlViewModel {

    /**
     * Das ViewModel für die Überschrift
     */
    public label: LabelViewModel;

    /**
     * Die ViewModels für die Elemente
     */
    public elements: KnockoutObservable<Array<StartpageElementViewModel>>;

    /**
     * Repräsentiert ein Element der Startseite
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.label = this.paramOrDefault(params.label, null);
        this.elements = this.observableOrDefault(params.elements, []);
    }
}

ComponentManager.setViewModel('StartpageGroupViewModel', StartpageGroupViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');